import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ca',
    fullName: 'Catalan',
    nativeName: 'Català',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "S'acosta alguna cosa increïble",
    landing_subtitle: "ArgVoid és un estudi de desenvolupament d'aplicacions i jocs. Estigueu atents, aviat arribaran coses noves!",
    select_language: "Seleccioneu Idioma",
    search_placeholder: "Cerca idiomes...",
    terms_title: "Condicions del servei",
    policy_title: "Política de privadesa",
    cookies_title: "Política de cookies",
    terms_content: `
        <strong>1. Acceptació de les condicions</strong><br>
        En accedir a ArgVoid, s'accepten aquestes Condicions del servei. Si no s'accepten aquests termes, no s'ha d'utilitzar el servei.<br><br>

        <strong>2. Ús de la plataforma</strong><br>
        ArgVoid i les seves aplicacions es proporcionen "tal qual" amb finalitats informatives i creatives. El servei només s'ha d'utilitzar amb finalitats lícites.<br><br>

        <strong>3. Conducta prohibida</strong><br>
        Està estrictament prohibit explotar les vulnerabilitats del lloc, enviar correu brossa o intentar accedir no autoritzat a la infraestructura.<br><br>

        <strong>4. Exempció de responsabilitat</strong><br>
        La plataforma i els serveis poden ser modificats en qualsevol moment sense previ avís. No s'ofereix cap garantia pel que fa al temps d'activitat o la disponibilitat del servei.
    `,
    policy_content: `
        <strong>1. Recull d'informació</strong><br>
        La plataforma no requereix autenticació d'usuari ni creació de compte en aquest moment. No es recopila activament cap informació d'identificació personal (com ara noms o adreces de correu electrònic) dels visitants.<br><br>

        <strong>2. Dades d'ús</strong><br>
        Es poden recopilar anàlisis bàsiques i anònimes per entendre el trànsit del lloc i millorar les aplicacions. Aquestes dades no estan enllaçades amb identitats d'usuari individuals.<br><br>

        <strong>3. Serveis de tercers</strong><br>
        Es poden utilitzar proveïdors de tercers per a serveis d'allotjament i anàlisi. Les pràctiques de privadesa d'aquests proveïdors respectius regeixen les dades anònimes processades a la seva infraestructura.<br><br>

        <strong>4. Seguretat de dades</strong><br>
        S'implementen mesures de seguretat raonables per protegir la plataforma. Tanmateix, cap mètode de transmissió per Internet és totalment segur.<br><br>
    `,
    cookies_content: `
        <strong>1. Què són les galetes i l'emmagatzematge local?</strong><br>
        Les galetes i l'emmagatzematge local del navegador són petits fitxers de dades emmagatzemats al dispositiu per recordar les preferències de configuració entre les visites.<br><br>

        <strong>2. Finalitat d'ús</strong><br>
        El navegador LocalStorage s'utilitza estrictament per desar els paràmetres de configuració, com ara:<br>
        - Preferències d'idioma<br>
        - Configuració de la interfície d'usuari (p. ex., configuració del disseny o del tema) <br>
        - Cau de l'aplicació temporal <br><br>

        <strong>3. Sense seguiment </strong><br>
        Les cookies i l'emmagatzematge local no s'utilitzen amb finalitats publicitàries o de seguiment de tercers. Totes les dades emmagatzemades són estrictament per a la funcionalitat bàsica de la plataforma.<br><br>

        <strong>4. Control</strong><br>
        Les dades del navegador es poden esborrar en qualsevol moment mitjançant la configuració del navegador, que restablirà qualsevol configuració local.
    `,
    cookie_consent_text: "Utilitzem galetes bàsiques per garantir que el lloc web funcioni correctament, com ara mantenir activa la vostra sessió, desar la vostra preferència d'idioma i altres configuracions personalitzades.",
    read_policy: "Llegeix la Política de Cookies",
    support_title: "Contacta amb l'assistència",
    support_subject_label: "Assumpte",
    support_message_label: "Missatge",
    support_submit_button: "Enviar missatge",
    support_hint: "Nota: Això obrirà la vostra aplicació de correu electrònic predeterminada per enviar el missatge.",
    support_success_msg: "S'està obrint l'aplicació de correu electrònic...",
    support_error_msg: "No s'ha pogut enviar el missatge. Si us plau, torna-ho a provar més tard.",
    explorer_title: "Explorador",
    history_title: "Història",
    animation_title: "Animació",
    config_title: "Configuració",
    tool_mouse: "Selecciona (Ctrl+M)",
    tool_brush: "Raspall (Ctrl+B)",
    tool_brush_mode: "Commuta el mode (sòlid/clar)",
    tool_eraser: "Goma d'esborrar (Ctrl+E)",
    tool_brush_size: "Ajusteu la mida del pinzell",
    tool_bucket: "Omplir (Ctrl+F)",
    tool_eyedropper: "Comptagotes",
    tool_grid: "Quadrícula (Ctrl+Maj+B)",
    tool_rotate: "Gira (Ctrl+Maj+R)",
    tool_flip_h: "Gira H (Ctrl+Maj+H)",
    tool_flip_v: "Gira V (Ctrl+Maj+V)",
    tool_transpose: "Transposa (Ctrl+Maj+T)",
    label_width: "Amplada",
    label_height: "Alçada",
    label_frames: "Nombre de fotogrames",
    label_animation: "Estil d'animació",
    label_background_color: "Color de fons",
    label_interval: "Interval",
    tool_anim_config: "Configuració d'animació",
    label_new_width: "Nova amplada",
    label_new_height: "Nova altura",
    label_apply: "Aplicar",
    label_colors: "Colors",
    label_size: "Mida",
    label_tolerance: "Tolerància",
    val_horizontal: "Horitzontal",
    val_vertical: "Vertical",
    val_sequence: "Seqüència",
    val_bounce: "Rebot",
    val_random: "Aleatori",
    val_solid: "Sòlid",
    val_clear: "Clar",
    action_add_sheet: "Full Nou",
    action_import: "Importar",
    action_export: "Exporta",
    action_sort_projects: "Ordena",
    sort_date_old: "El més vell primer",
    sort_date_new: "El més nou primer",
    sort_name_az: "Nom (A-Z)",
    sort_name_za: "Nom (Z-A)",
    action_new_sprite: "Nou Sprite",
    action_new_project: "Nou Projecte",
    modal_save_all_title: "Desa tots els canvis",
    modal_save_all_desc: "Seleccioneu els actius que voleu desar:",
    modal_save_selected: "Desa la selecció",
    action_saved: "Desat",
    modal_create_sprite_title: "Crea un Sprite nou",
    modal_create_project_title: "Crea un nou projecte",
    modal_add_sheet_title: "Afegeix un full nou",
    modal_rename_sheet_title: "Canvia el nom del full",
    modal_rename_sprite_title: "Canvia el nom de Sprite",
    modal_delete_sprite_title: "Suprimeix Sprite",
    modal_delete_project_title: "Esborra projecte",
    modal_delete_sheet_title: "Suprimeix el full",
    placeholder_sprite_name: "Nom",
    placeholder_project_name: "Nom",
    placeholder_sheet_name: "Nom",
    placeholder_new_name: "Nom nou",
    action_create: "Crear",
    action_add: "Afegeix",
    action_rename: "Canvia el nom",
    action_duplicate: "Duplicat",
    action_delete: "Suprimeix",
    action_cancel: "Cancel·la",
    confirm_delete_sprite: "Esteu segur que voleu suprimir aquest sprite?",
    confirm_delete_project: "Esteu segur que voleu suprimir aquest projecte? S'eliminaran tots els sprites.",
    confirm_delete_sheet: "Esteu segur que voleu suprimir aquest full?",
    err_select_sprite: "Seleccioneu primer un sprite.",
    err_select_project: "Seleccioneu primer un projecte.",
    err_name_empty: "El nom no pot estar buit.",
    err_sprite_exists: "Un sprite amb aquest nom ja existeix.",
    err_project_exists: "Un projecte amb aquest nom ja existeix.",
    err_no_content: "No hi ha contingut per guardar.",
    err_no_changes: "No hi ha canvis per desar.",
    err_delete_last_sheet: "No es pot suprimir l'últim full.",
    err_extract_frames: "No s'ha pogut extreure cap marc.",
    err_indexeddb: "No s'ha pogut desar localment. És possible que el vostre navegador no admeti IndexedDB.",
    msg_upload_success: "Pujada correcta: {0}",
    msg_upload_failed: "No s'ha pogut carregar: {0}",
    msg_save_success: "Desa correctament.",
    msg_saving: "S'està desant...",
    msg_multi_save_result: "S'han desat {0} recursos. {1} errors.",
    menu_title: "Menú",
    menu_save: "Desa",
    menu_save_all: "Desa-ho tot",
    menu_support: "Contacta amb l'assistència",
    label_local_storage: "Emmagatzematge local",
    label_sign_in: "Inicieu la sessió",
    modal_export_title: "Exporta Sprite",
    label_filename: "Nom del fitxer",
    label_format: "Format",
    action_export_confirm: "Exporta",
};

export default translations;
